import { isMobile } from '~/genericFunctions';

const webOrMobile = (ismobile) => isMobile(ismobile) ? 'MOBILE' : 'WEB';

export const getHeaders = ({ globalData: { ismobile, locale } }) => ({
  'Content-Type': 'application/json',
  'X-HSBC-Channel-Id': webOrMobile(ismobile),
  'X-HSBC-Locale': locale,
  'X-HSBC-Chnl-CountryCode': 'MX',
  'X-HSBC-Chnl-Group-Member': 'HBMX',
  'X-HSBC-Customer-Ip': '127.0.0.1',
  'X-HSBC-Session-Id': 'cdab162f7235427a0eb15260bc36d8864a4749dd',
  'X-Content-Type-Options': 'nosniff',
});
